// Logged-in app page: Music library (routes/Music.tsx). Keep keys in sync with pl/appMusic.ts.
export const appMusic = {
  head: {
    title: 'Music',
  },
  upload: {
    progressLabel: 'Upload progress',
    abort: 'Stop',
    failedPill: 'not uploaded',
    queued: 'queued',
    retry: 'Try again',
    dismiss: 'Remove from the list',
  },
  trim: {
    title: 'Choose the fragment to upload',
    // The fragment cap as a label beside the “Length” readout.
    maxLen: 'max {max} s',
    preparing: 'Preparing the waveform locally…',
    // A pill in the dialog header; the full sentence stays for the reader and in `title`.
    localOnly: 'the file stays on your device',
    localOnlyFull: 'The original audio or video file stays on this device. Only the selected audio fragment is uploaded.',
    start: 'Start',
    end: 'End',
    length: 'Length',
    play: 'Play from start',
    pause: 'Pause',
    playEnding: 'Audition the ending',
    pauseEnding: 'Pause ending',
    fullMode: 'Full fragment',
    endingMode: 'Ending loop',
    readyToPlay: 'Ready to audition',
    fades: 'Fragment fades',
    enableFades: 'Enable fade in and fade out',
    fadeIn: 'Fade in',
    fadeOut: 'Fade out',
    fadeHelp: '0-{max} s on each side',
    playbackError: 'The fragment could not play. Try again.',
    keyboard: 'Space: pause. Press again to play from the fragment start.',
    cancel: 'Cancel',
    confirm: 'Upload this fragment',
    // The in-between window of a multi-file run charges nothing, so it carries no cost.
    next: 'Next',
    decodeError: 'The audio could not be read. The file may have no audio track, or its audio format may not be supported. Choose another file.',
    tooLarge: 'File too large · limit {max} MB',
  },
  wave: {
    computing: 'Computing the waveform',
    fromFile: 'from the audio file',
  },
  empty: {
    title: 'Upload your first track',
  },
  toolbar: {
    upload: 'Upload track',
  },
  error: {
    title: 'The tracks could not be loaded.',
  },
  // SIX STATE WORDS (rule 45, table M2). The state speaks about the LYRICS: the
  // artist judges a track by whether the captions will be good. Background technical
  // work (beat, waveform, recomputes) has no state and no word of its own — while
  // anything is still running the track is "analysing", and a permanent background
  // failure makes it "analysis error". One dictionary everywhere a track is shown.
  state: {
    analyzing: 'analysing',
    noText: 'no lyrics',
    auto: 'auto lyrics',
    approved: 'lyrics approved',
    analysisError: 'analysis error',
    fileError: 'file error',
  },
  actions: {
    retry: 'Retry',
    retryText: 'Retry the lyric analysis',
    uploadOther: 'Upload another version',
    use: 'Use',
    deleteFailed: 'Could not delete the track.',
  },
  menu: {
    more: 'More actions: {name}',
    editText: 'Edit lyrics',
    remove: 'Delete',
    delete: 'Delete track',
  },
  cost: {
    cost: 'Cost',
    have: 'You have',
    left: 'Left',
    missing: 'Short by',
  },
  short: {
    title: 'Not enough tokens',
    topUp: 'Buy tokens',
  },
  retryText: {
    title: 'Retry the lyric analysis?',
    approvedRow: 'Approved lyrics',
    approvedValue: 'will be replaced',
  },
  failure: {
    title: 'Analysis error',
    refundRow: 'Tokens returned',
    close: 'Close',
  },
  leave: {
    title: 'Stop?',
    body: 'The upload is still running. If you leave, it starts over.',
    stay: 'Stay',
    leave: 'Leave',
  },
  toast: {
    uploaded: 'Track uploaded.',
    uploadedMany: 'Uploaded {n} tracks.',
    uploadedMany_one: 'Uploaded {n} track.',
    uploadedMany_few: 'Uploaded {n} tracks.',
    uploadedMany_many: 'Uploaded {n} tracks.',
    deleted: 'Track deleted.',
    aborted: 'Upload stopped.',
    retried: 'Analysis retried.',
    retriedCost: 'Analysis retried',
    analysisFailed: 'Analysis error.',
    analysisFailedRefund: 'Analysis error',
    deleteFailed: 'Could not delete the track.',
  },
  delete: {
    ask: 'Delete "{name}"?',
    body: 'The file and the lyrics will be gone. Rendered series stay.',
    rowFile: 'File',
    rowText: 'Lyrics',
    words: '{n} words',
    words_one: '{n} word',
    words_few: '{n} words',
    words_many: '{n} words',
    noText: 'no lyrics',
    cancel: 'Cancel',
  },
  // 46-A (package PS): the "Track plays" sheet (frame 02b). The row element uses the
  // `appStats.tracks.*` keys - one source for the ring's text.
  stats: {
    title: 'Track plays',
    thresholds: 'Milestones',
    posts: 'Posts · {count}',
    // The element button's name for screen readers.
    open: 'Plays for {track}',
  },
}
